import updateMultiCarrierEligibility from 'core/controllerPlans/update-multi-carrier-eligibility'
import parseResponseSTM from 'core/services/getPlansByProductId/parseResponseSTM'
import validateProfile from 'core/controllerPlans/validateProfile'
import { getPlansEnroll } from 'core/controllerPlans/getPlans'
import handleException from 'core/controllers/handleException'
import loadSignatureDocument from './load-signature-document'
import updateStorages from './updateStorages'
import initPage from 'core/initPage'

export function initController(config) {
  return loadSignatureDocument({
    tryLoad: config.tryLoadHcStorage
  })
    .then(signatureDocument =>
      initPage({
        placement: config.placement,
        chatInteractionId: config.chatInteractionId,
        tags: [config.tagMaropost],
        clearStorage: config.clearStorage || false,
        signatureDocument
      })
    )
    .then(updateStorages)
    .then(updateMultiCarrierEligibility)
    .then(validateProfile)
    .then(getPlansEnroll)
    .then(parseResponseSTM)
    .catch(handleException())
}

export default initController
